// Video Vendors
export const JWPLAYER_VENDOR = 1;
export const VIDEO_JS_VENDOR = 2;

// Ad Server Vendors
export const GAM_VENDOR = 'gam';
